import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import NotFound from './common/NotFound';

export const router = createRouter({ routeTree, defaultNotFoundComponent: NotFound });
